module.exports = __webpack_public_path__ + "img/sirion.0aedcfd7.png";